import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-nxf96eG-.js';

const defaultTheme = stormLightTheme;

export { defaultTheme as d };
//# sourceMappingURL=index-CEAohMpO.js.map
